import Config from '../Config';
import { RestService } from './RestService';

export const FCMService = {
    register: async function(mobile_no, platform, body = {}, header = {}){
        return RestService.post(`${Config.register_fcm_url}mobile_no=${mobile_no}&platform=${platform}`, header, body)
        .then(response => response.json())
    },
    unregister: async function(body = {}, header = {}){
        return RestService.post(Config.unregister_fcm_url, header, body)
    },
};